import React from "react";
import { string, func } from "prop-types";

import "./loadMore.m.css";

const LoadMore = ({ content, onClick, ...props }) => (
  <button styleName="wrapper" className="loadmore" onClick={onClick} {...props}>
    {content}
  </button>
);

LoadMore.defaultProps = {
  content: "Load More",
};

LoadMore.propTypes = {
  content: string,
  onClick: func,
};

export default LoadMore;
